import EventBus from "../event-bus";

export default {
    data() {
        return {
            eventListeners: []
        };
    },
    
    mounted() {
        this.eventListeners.forEach(({ event, handler }) => {
            EventBus.on(event, handler);
        });
    },
    
    beforeUnmount() {
        this.eventListeners.forEach(({ event, handler }) => {
            EventBus.off(event, handler);
        });
    },
    
    methods: {
        addEvent(event, handler) {
            this.eventListeners.push({ event, handler });
            EventBus.on(event, handler);
        },
        
        removeEvent(event, handler) {
            EventBus.off(event, handler);
        },
        
        emitEvent(event, data) {
            EventBus.emit(event, data);
        }
    }
}; 